import React from "react";
import RentalInfoForm from "../../../../../rentals/info/RentalInfoForm";

class BicycleRentalInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            backUrl: '/system/' + this.props.match.params.systemId + '/bicycle/' + this.props.match.params.bicycleId + '/rentals',
        };
    }

    render() {
        return (
            <RentalInfoForm backUrl={this.state.backUrl}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}/>
        )
    }
}

export default BicycleRentalInfo;